import FtdLoadedFromTotal from "../../../../components/AssetManagement/Overview/BusinessLeaderDashboard/AdditionalQueries/FTDLoadedFromTotal/FtdLoadedFromTotal";

const FtdLoadedFromTotalScreen = () => {
  return (
    <div>
      <FtdLoadedFromTotal />
    </div>
  );
};

export default FtdLoadedFromTotalScreen;
